const env = process.env.NODE_ENV || 'development';

const apiEnvironment = {
  development: {
    api: 'https://sonladev-api.cgis.asia',
    apiCustom: 'https://pahtsonla-api.cgis.asia',
    domainUserSide: 'http://localhost:3000',
    domainAdminSide: 'http://localhost:3000',
    domainName: '',
    doMainNameGeoServer: 'https://geo.cgis.asia/geoserver/wfs',
    doMainNameGeoServerWMS: 'https://geosonla.cgis.asia/geoserver/sonla/wms/',
    datastore: 'sonla',
  },
  // production: {
  //   api: 'https://sonladev-api.cgis.asia',
  //   apiCustom: 'https://pahtsonla-api.cgis.asia',
  //   domainUserSide: 'https://sonladev.cgis.asia',
  //   domainAdminSide: 'https://admin.sonladev.cgis.asia',
  //   domainName: 'cgis.asia',
  //   doMainNameGeoServer: 'https://geo.cgis.asia/geoserver/wfs',
  //   doMainNameGeoServerWMS: 'https://geosonla.cgis.asia/geoserver/sonla/wms/',
  //   datastore: 'sonla',
  // },
  // development: {
  //   api: 'https://api.tracuuquyhoachsonla.vn/',
  //   apiCustom: 'https://paht-api.tracuuquyhoachsonla.vn',
  //   domainUserSide: 'http://localhost:3000',
  //   domainAdminSide: 'http://localhost:3000',
  //   domainName: '',
  //   doMainNameGeoServer: 'https://geo.tracuuquyhoachsonla.vn/geoserver/wfs',
  //   doMainNameGeoServerWMS: 'https://geo.tracuuquyhoachsonla.vn/geoserver/sonla/wms/',
  //   datastore: 'sonladev_v2',
  // },
  production: {
    api: 'https://api.tracuuquyhoachsonla.vn/',
    apiCustom: 'https://paht-api.tracuuquyhoachsonla.vn',
    domainUserSide: 'https://tracuuquyhoachsonla.vn',
    domainAdminSide: 'https://admin.tracuuquyhoachsonla.vn',
    domainName: 'tracuuquyhoachsonla.vn',
    doMainNameGeoServer: 'https://geo.tracuuquyhoachsonla.vn/geoserver/wfs',
    doMainNameGeoServerWMS: 'https://geo.tracuuquyhoachsonla.vn/geoserver/sonla/wms/',
    datastore: 'sonladev_v2',
  },
};

module.exports = apiEnvironment[env];
